
import Vue from "vue";
import * as types from "@/store/mutation-types";
import { FormBlock } from "@/components/FormBuilder/types";
import { watercraftTypeFormSchema } from "@/forms/admin/watercraftType";
import {
  watercraftTypeMapActions,
  watercraftTypeMapMutations,
  watercraftTypeMapState
} from "@/store/modules/watercraftType";

export default Vue.extend({
  name: "CreateWatercraftTypeView",
  data() {
    return {
      isLoading: false,
      loadingText: "",
      errorMessage: "",
      successMessage: "",
      disablePrimaryButton: true
    };
  },
  created() {
    this.SET_EDIT({} as any);
  },
  destroyed() {
    this.SET_EDIT(" " as any);
  },
  computed: {
    ...watercraftTypeMapState(["editing", "makingApiRequest"]),
    watercraftTypeFields(): FormBlock[] {
      return watercraftTypeFormSchema;
    }
  },
  methods: {
    ...watercraftTypeMapMutations(["SET_EDIT"]),
    ...watercraftTypeMapMutations({ editField: types.SET_EDIT_FIELD }),
    ...watercraftTypeMapActions(["createWatercraftType"]),
    validationChangeHandler(e: any) {
      const { formIsValid } = e;
      this.disablePrimaryButton = !formIsValid;
    },
    formFieldChangeHandler({ key, value }: { key: any; value: any }) {
      this.editField({ key, value });
    },
    async toolbarSelectItem(event: string) {
      switch (event) {
        case "saveWatercraftType":
          await this.submit();
          break;
        case "cancelWatercraftType":
          this.$router.push("/admin/watercraftTypes").catch(() => {});
          break;
      }
    },
    async submit(): Promise<void> {
      try {
        this.loadingText = "Creating watercraft type. Please wait...";
        this.isLoading = true;
        await this.createWatercraftType({
          label: this.editing?.label,
          value: this.editing?.value
        });
        this.$appNotifySuccess("Watercraft Type created");
        this.$router.replace("/admin/watercraftTypes");
      } catch (error) {
        this.errorMessage = error.message;
        this.$bugSnagClient.notify(error);
      } finally {
        this.isLoading = false;
        this.loadingText = "";
      }
    }
  }
});
